import styled from 'styled-components'

export const Container = styled.div`
    .actions {
        display: flex;
        flex-direction: column;
        gap: 10px;

        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;

        h3 {
            font-family: 'Inter';
        }

        .exports {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
        }

        button {
            display: flex;
            align-items: center;
            gap: 4px;
            font-family: 'Poppins';
            font-weight: 500;
            color: #3c363b;
            border: 1px solid #d3d3d3;
            padding: 4px 6px;
            border-radius: 8px;
            cursor: pointer;
            svg {
                color: #6d756a;
            }
        }

        @media (min-width: 566px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0;
        }
    }
    .contrato {
        display: flex;
        flex-direction: column;
    }

    .group {
        .wrapper {
            border-bottom: 1px solid #d3d3d3;
            display: flex;
            flex-direction: column;
            gap: 40px;
            padding: 18px 0;

            @media (min-width: 768px) {
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
        }

        p {
            font-family: 'Inter';
            @media (min-width: 900px) {
                white-space: nowrap;
            }
            span {
                font-weight: 600;
            }
        }

        &.obs {
            /* margin-bottom: 20px; */
            border-bottom: 1px solid #d3d3d3;
            padding: 20px 0;

            p:first-child {
                font-weight: 600;
                margin-bottom: 10px;
            }

            p {
                font-family: 'Inter';
            }
        }

        &.erros {
            margin-top: 20px;
            h3 {
                font-family: 'Roboto';
                font-weight: 500;
                font-size: 22px;
            }
            .item-erro {
                padding: 10px;
                background: rgba(255, 0, 0, 0.5);
                position: relative;
                margin-bottom: 10px;
                color: #000000;
                font-family: 'Poppins';
                font-weight: 400;
                font-size: 14px;
                cursor: pointer;
                border-radius: 0 6px 6px 0;

                &:hover {
                    opacity: 0.9;
                }

                &::before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 4px;
                    height: 100%;
                    background: #ff0000;
                    border-radius: 0 10px 10px 0;
                }
            }
        }
    }
`

export const Content = styled.div`
    border-bottom: 1px solid #d3d3d3;
    padding: 15px 0;
    margin-bottom: 15px;
    h3 {
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
        font-size: 21px;
        margin-bottom: 8px;
    }

    h4 {
        font-family: 'Roboto', sans-serif;
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 5px;
    }

    .input-group {
        padding: 10px 0;
    }

    .input-group:not(:last-child) {
        border-bottom: 1px solid #d3d3d3;
    }

    .receiver {
        margin-bottom: 10px;
    }

    .wrapper {
        margin-bottom: 5px;

        p {
            font-family: 'Inter', sans-serif;
            font-size: 17px;
        }

        p + p {
            margin-top: 6px;
        }

        .situation {
            font-size: 18px;
        }

        .op,
        .canal {
            font-size: 15px;
        }
    }

    .details {
        p {
            font-size: 15px;
        }
    }
    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .bank-address {
        display: flex;
        flex-direction: column;
    }
    @media (min-width: 678px) {
        .bank-address {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }
`

export const Agenda = styled.div`
    h2 {
        font-family: 'Roboto';
        font-weight: 500;
        min-width: max-content;

        &.center {
            text-align: center;
        }
    }

    .details {
        margin: 12px 0;
        p {
            font-family: 'Inter', sans-serif;
            font-size: 15px;
        }
    }
`

export const UnidadesRecebiveis = styled.div`
    margin-top: 10px;
    overflow: auto;
`

export const Table = styled.table`
    width: 100%;
    text-align: left;
    border-collapse: collapse;
    /* table-layout: fixed; */
    margin-top: 20px;
    /* overflow: scroll; */
    min-width: 800px;

    thead {
        /* background: #D3D3D3; */
        border-bottom: 1px solid #d3d3d3;

        tr {
            border-radius: 8px;
        }
        th {
            color: #333;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 4px;
        }
    }

    tbody {
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }
        td {
            padding: 10px 4px;
        }
    }
`
